export const ACCOUNT_TAB = 'ACCOUNT_TAB';